// Single source of truth for the API base URL.
//
// Production: built with VITE_API_BASE pointing at the deployed Django host
// (e.g. https://api.deployments.linzametrics.com or
// https://api.staging.linzametrics.com). The bundled value is final.
//
// Development: vite.config.ts proxies /proxy/deployments and /proxy/demo to
// the upstream APIs to dodge CORS. We map the production hosts to those
// proxy paths so the same fetch URLs work locally.

const RAW_BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';

const DEV_PROXY_MAP: Record<string, string> = {
  'https://api.deployments.linzametrics.com': '/proxy/deployments',
  'https://api.demo.linzametrics.com': '/proxy/demo',
};

export const API_BASE: string = (() => {
  if (!RAW_BASE) return '';
  if (import.meta.env.DEV) return DEV_PROXY_MAP[RAW_BASE] ?? RAW_BASE;
  return RAW_BASE;
})();

// The "real" host (no DEV proxy rewrite). Used when an absolute URL is
// required, e.g. building image src for media served by the same host.
export const API_HOST: string = RAW_BASE;
